import React from 'react';
import {injectIntl} from 'react-intl';
import {salaryFormatter} from 'salaryFormatter';
import getJobLocationData from 'getJobLocationData';
import {customDateFormat} from 'dateFormatter';
import Icon from '@Components/Icon';

const JobCard = ({intl, jobData, configurations, backgroundColorClass}) => {
  // eslint-disable-next-line camelcase
  const {card_settings} = configurations || {};
  let {description, lobName, type, workHours, createdDate} = jobData;
  const useLowerCase = process.env.REACT_APP_USE_LOWER_CASE === 'true';
  const salary = salaryFormatter(jobData, false, false, intl);
  const location = getJobLocationData(jobData, intl);
  let url = jobData.JobUrl;
  // Add trailing slash at the end of link.
  if (url && typeof url === 'string') {
    url = url.substr(url.length - 1) === '/' ? url : `${url}/`;
  }
  // Format date.
  const date = customDateFormat(createdDate, 'M d, Y');

  // Strip tags and trim to 150 symbols.
  description = description.replace(/<[^>]*>?/gm, '');

  let companyName = null;

  if (lobName) {
    companyName = useLowerCase ? lobName.toLowerCase() : lobName;
  }

  if (type) {
    type = useLowerCase ? type.toLowerCase() : type;
  }

  const ListItem = ({icon, text}) => (
    <li className="cards__meta-item">
      <span className="icon icon--inline">
        <Icon type={icon}/>
      </span>
      {text}
    </li>
  );

  const cardInfoClick = (event) => {};

  return (
    <li
      className={`cards__item ${backgroundColorClass}`}
      data-rs-card=""
      data-rs-carousel-card=""
      data-rs-active-state="cards__item--active"
    >
      <div className="cards__header">
        <div className="cards__logo-title-container">
          <h3 className="cards__title">
            <a
              className="cards__link"
              href={url}
              onMouseDown={() => eval(jobData.dataLayerJobClick)}
              rel="noreferrer"
            >
              {jobData.title}
              <span className="make-entire-card-clickable"/>
            </a>
          </h3>
        </div>
      </div>
      <ul className="cards__meta">
        {
          // eslint-disable-next-line camelcase
          card_settings && card_settings.location_settings && card_settings.location_settings.checked && location ?
            <ListItem
              icon={card_settings.location_settings.icon ?
                card_settings.location_settings.icon : 'marker'}
              text={location} alternative={true}
            /> :
            null
        }
        {
          // eslint-disable-next-line camelcase
          card_settings && card_settings.jobtype_settings && card_settings.jobtype_settings.checked && type ?
            <ListItem
              icon={card_settings.jobtype_settings.icon ?
                card_settings.jobtype_settings.icon : 'briefcase'}
              text={type} alternative={true}
            /> :
            null
        }
        {
          // eslint-disable-next-line camelcase
          card_settings && card_settings.salary_settings && card_settings.salary_settings.checked && salary ?
            <ListItem
              icon={card_settings.salary_settings.icon ?
                card_settings.salary_settings.icon : 'salary'}
              text={salary} alternative={true}
            /> :
            null
        }
        {
          // eslint-disable-next-line camelcase
          card_settings && card_settings.hours_settings && card_settings.hours_settings.checked && workHours?.length ?
            <ListItem
              icon={card_settings.hours_settings.icon ?
                card_settings.hours_settings.icon : 'clock'}
              text={workHours[0]} alternative={true}
            /> :
            null
        }
        {
          // eslint-disable-next-line camelcase
          card_settings && card_settings.division_settings && card_settings.division_settings.checked && companyName ?
            <ListItem
              icon={card_settings.division_settings.icon ? card_settings.division_settings.icon : 'calendar'}
              text={companyName} alternative={true}
            /> :
            null
        }
      </ul>
      <div className="cards__footer">
        <div className="cards__time-info">
          <span
            className="cards__date text--alternative"
          >{intl.formatMessage({id: 'JobDetails.OpenDate.DateFormat'}, {date: date})}</span>
        </div>
        <div className="cards__info-wrapper" data-rs-card-show-backside="">
          <span className="cards__info-button text--alternative" onClick={cardInfoClick}>
            <span className="icon icon--inline">
              <Icon type="info"/>
            </span>
          </span>
        </div>
      </div>
      <div className="cards__backside-card">
        <div className="cards__backside-description" lang="en">{description}</div>
        <div className="cards__backside-footer">
          <a
            href={url} onMouseDown={() => eval(jobData.dataLayerJobClick)}
            className="cards__backside-footer__button cards__backside-footer--job-link"
          >
            <span className="icon icon--inline">
              <Icon type="eye"/>
            </span>
            {intl.formatMessage({id: 'JobItemList.ViewJob'})}
          </a>
          <div data-rs-card-hide-backside="" className="cards__backside-footer__button cards__backside-footer--close-backside">
            <span className="icon icon--inline">
              <Icon type="close"/>
            </span>
          </div>
        </div>
      </div>
    </li>
  );
};

export default injectIntl(JobCard);
